import { render, staticRenderFns } from "./ds_more.vue?vue&type=template&id=7f4d090b&scoped=true&"
import script from "./ds_more.vue?vue&type=script&lang=js&"
export * from "./ds_more.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4d090b",
  null
  
)

export default component.exports